// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { InvoiceStateContext } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Img from "@insite/mobius/Img";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { ImgProps } from "@steiner/MobiusOverrides/Img/Img";
import React, { useContext } from "react";

export interface InvoicePodSignatureStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyPresentationProps;
    img?: ImgProps;
}

export const invoicePodSignatureStyles: InvoicePodSignatureStyles = {};

const styles = invoicePodSignatureStyles;

const InvoiceDetailsPodSignature = () => {
    const { value: invoice } = useContext(InvoiceStateContext);
    if (!invoice || !invoice.properties || !invoice.properties.orderBase64Img) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="InvoiceDetailsPodSignature">
                {translate("Proof of Delivery Signature image")}
            </Typography>
            <Img {...styles.img} src={`data:image/png;base64,${invoice.properties.orderBase64Img}`} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: InvoiceDetailsPodSignature,
    definition: {
        allowedContexts: ["InvoiceDetailsPage", "VmiInvoiceDetailsPage"],
        group: "Invoice Details",
    },
};

export default widgetModule;
